import { Log, Level, Logger } from 'ng2-logger';
import Types, { IAppState, GlobalState, ISetActivityType } from '../../models/action/core.d';
import { IMainSetMenuAction, IMainCourseMenuTabSetAction, IMainCourseMenuContentSetAction } from '../../models/action/main-menu';
import * as Actions from '../constants/all';
const _logger = Log.create('Main-Menu Reducer');

const mainMenuReducer = (state = GlobalState().mainMenuRoot, action: Types.IAction) => {
    if (!state) {
        return state;
    }
    let newState: any = {};
    if (action.type === Actions.mainMenuActions.SET_MAIN_MENU_DATA) {
        const mainMenuAction = action as IMainSetMenuAction;
        newState = { ...state };
        newState.mainMenu = mainMenuAction.mainMenu;
    } else 
    if (action.type === Actions.mainMenuActions.SET_MAIN_COURSEMENU_TAB_DATA) {
        const mainMenuTabAction = action as IMainCourseMenuTabSetAction;
        newState = { ...state };
        newState.courseSubNavigationTabParam = mainMenuTabAction.courseSubNavigationTabParam;
        newState.menuPanelItems = mainMenuTabAction.menuPanelItems;
        newState.tabActiveStatus = mainMenuTabAction.tabActiveStatus;
        newState.courseMenuPanelItemsIsLoaded = mainMenuTabAction.courseMenuPanelItemsIsLoaded;
    } else if (action.type === Actions.mainMenuActions.SET_MAIN_COURSEMENU_CONTENT_DATA) {
        const mainMenuContentAction = action as IMainCourseMenuContentSetAction;
        newState.mainMenuCourseContent = mainMenuContentAction.mainMenuCourseContent;
    } else if (action.type === Actions.coreActions.SET_ACTIVITYTYPE_WITHMODAL) {
        const coursePageAction = action as ISetActivityType;
        newState.activityAddType = coursePageAction.activityType;
        newState.activityAddId = coursePageAction.activityId;
    } else {
        return state;
    }

    const returnState = Object.assign({}, state, newState);
    return returnState;
};
export default mainMenuReducer;
